export default __webpack_public_path__ + "static/media/avatar.dbe265a1.jpeg";